import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { e2eLocators } from '@components/add-destination-alternate-form/add-destination-alternate-form.constants';
import { CompaniesPickerComponent } from '@components/companies-picker/companies-picker.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { CardComponent, CardGroupComponent, InputComponent } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared@models';
import { Destination, StorageAccountV2 } from 'mbs-ui-shared@models/StorageAccount';

@UntilDestroy()
@Component({
  selector: 'mbs-add-destination-alternate-form',
  templateUrl: './add-destination-alternate-form.component.html',
  imports: [
    CardComponent,
    CardGroupComponent,
    CommonModule,
    CompaniesPickerComponent,
    NgbTooltipModule,
    ReactiveFormsModule,
    I18NextPipe,
    InputComponent
  ]
})
export class AddDestinationAlternateFormComponent implements OnInit {
  private i18N = inject(I18NextPipe);

  @Input() form: FormGroup;
  @Input() destination: Destination;
  @Input() storageAccount: StorageAccountV2;
  @Input() viewMode: 'modal' | 'wizard' = 'modal';

  public readonly StorageType = StorageType;
  public readonly e2eLocators = e2eLocators;

  public rootFolderName: string;
  @Input() public companiesLocked = false;
  @Input() public selectedCompanyIds: string[] = [];
  @Input() public hideCompanies = false;

  ngOnInit() {
    if (this.storageAccount.storageType === StorageType.LocalFS) {
      this.rootFolderName = this.i18N.transform('shared:common.path', { format: 'capitalize' });
    } else if (this.storageAccount.storageType === StorageType.AzureVM) {
      this.rootFolderName = this.i18N.transform('shared:common.bucket');
      this.form.get('bucketName').patchValue('main');
    } else {
      this.rootFolderName = this.i18N.transform('shared:common.rootFolder');
    }

    if (this?.destination?.isReadOnly) {
      return void this.form.disable();
    }

    if (this.destination) {
      this.selectedCompanyIds = this.destination?.assignedCompanies || [];
      this.form.patchValue({
        displayBucketName: this.destination.displayName,
        bucketName: this.destination?.bucket?.bucketName
      });
    }
  }
}
